export const VISIT_STORE_CTA = 'Visit Store';


export enum REDIRECT_LOCATION {
  MIXED_RESULTS = 'mixed_results_callout',
  ZERO_RESULTS = 'zero_results_callout',
}

export enum TRIGGER_TYPE {
  AUTOMATIC = 'automatic',
  MANUAL = 'manual',
}